/** Dirección de un enlace escrito a mano en el redactor o la firma (M27, auditoría 2026-10-02).
 *  «orvian.mx» → «https://orvian.mx», «ana@x.mx» → «mailto:ana@x.mx». Lo que no sea http(s),
 *  mailto o tel (p. ej. «javascript:…») se rechaza: devuelve null. */
export function normalizarEnlace(texto) {
  const t = String(texto || '').trim();
  if (!t) return null;
  if (/^(https?:\/\/|mailto:|tel:)/i.test(t)) return /\s/.test(t) ? null : t;
  if (/^[a-z][a-z0-9+.-]*:/i.test(t) && !/^[^:]+:\d/.test(t)) return null;   // otro esquema (javascript:, data:…)
  if (/^[^\s@/]+@[^\s@/]+\.[^\s@/]+$/.test(t)) return `mailto:${t}`;
  if (/\s/.test(t) || !/\./.test(t)) return null;
  return `https://${t.replace(/^\/+/, '')}`;
}
